function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0_arrow{fill:#1f9ed9;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0_arrow",
  d: "M3.6,6.4l5.1-4.6c0.5-0.4,0.5-1.1,0-1.5c-0.5-0.4-1.1-0.4-1.5,0L0.3,6.8c-0.5,0.4-0.5,1.1,0,1.5l6.8,6.5 C7.4,14.9,7.6,15,7.9,15c0.3,0,0.5-0.1,0.8-0.3c0.5-0.4,0.5-1.1,0-1.5L3.6,8.6C3.6,8.6,2.2,7.7,3.6,6.4z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_1_1_"
});

var SvgArrowSxSimple = function SvgArrowSxSimple(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    width: "9px",
    height: "15px",
    viewBox: "0 0 9 15",
    style: {
      enableBackground: "new 0 0 9 15"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowSxSimple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-sx-simple.d4fcacb3.svg";
export { ForwardRef as ReactComponent };